import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Order } from 'services/action';

import { Page, Button } from 'ui/components';
import { General, FormShipments } from './component/form';

import { UTCFormat } from 'utilities/common';

const initialState = {
  form_general: null,
  shipments: [],
  isLoading: true,
};

const CreateScreen = () => {
  const History = useHistory();
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state?.Form);

  const [
    { form_general, shipments, isLoading },
    setState,
  ] = React.useState(initialState);


  const $handleSubmit = async () => {
    let newList = [];

    if (form_general?.service?.auto_manifest) {
      await shipments.forEach((data, key) => {
        let type = 'drop_point'
        if (key === 0) {
          type = 'pickup'
        }

        if (data?.etd_at === '-') {
          data.etd_at = UTCFormat(form_general?.etd_at?.formatted, form_general?.etd_time, true)
        }

        newList.push({
          shipment_customer_id: data?.shipment_customer_id,
          origin_id: data?.origin_id,
          destination_id: data?.destination_id,
          etd_at: data?.etd_at,
          eta_at: data?.eta_at,
          items: data?.items,
          type: type,
          pickup_note: data?.pickup_note,
          instruction: data?.instruction,
        });
      });
    } else {
      await shipments.forEach((data) => {
        if (data?.etd_at === '-') {
          data.etd_at = UTCFormat(form_general?.etd_at?.formatted, form_general?.etd_time, true)
        }

        newList.push({
          shipment_customer_id: data?.shipment_customer_id,
          origin_id: data?.origin_id,
          destination_id: data?.destination_id,
          etd_at: data?.etd_at,
          eta_at: data?.eta_at,
          items: data?.items,
          instruction: data?.instruction,
          ref_code: data?.ref_code,
          unit_price: data?.unit_price,
          cod_value: data?.cod_value,
        });
      });
    }

    const payload = {
      customer_id: form_general?.customer?.id,
      ref_code: form_general?.ref_code,
      service_type_id: form_general?.service_type?.id,
      note: form_general?.note,
      shipper: form_general?.shipper,
      shipments: newList,
    };

    if (form_general?.service?.auto_manifest) {
      payload.type = 'ftl';
      payload.unit_price = form_general?.unit_price;
    } else {
      payload.type = 'ltl';
    }

    const req = await Dispatch(Order.$create(payload));

    if (req?.message === 'success') {
      History.push(`/order/${req?.data?.id}`);
    }
  };

  React.useEffect(() => {
    setTimeout(() => {
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }, 2000);
  }, []);

  return (
    <Page type="form" onSubmit={$handleSubmit} className="detail-fixed">
      <Page.Header
        title="Buat Order Customer"
        className="bg-light"
        backTo="/order/customer"
      />

      <Page.Body className="row bg-light border-top">
        <div
          className="col-12 col-md-4 position-md-fixed bg-white h-100 border-end border-sm-none"
          style={{ paddingRight: 10 }}
        >
          <General
            onChange={(e) =>
              setState((prevState) => ({ ...prevState, form_general: e }))
            }
            isLoading={isLoading}
          />
        </div>

        <div className="col-md-8 col-12 offset-md-4 pe-0 ps-0 ps-md-0 mt-5 mt-md-0">
          <div className="py-md-3 ps-md-3 ">
            <FormShipments
              isLoading={isLoading}
              onChange={(e) =>
                setState((prevState) => ({ ...prevState, shipments: e }))
              }
              customer={form_general?.customer}
              service={form_general?.service}
            />
          </div>
        </div>
      </Page.Body>

      <Page.Footer className="bg-light justify-content-center gap-md-2 pt-2 pb-3 mb-2 mb-md-0 border-top d-md-flex d-block flex-wrap">
        <Button
          type="button"
          className="btn-secondary py-md-2"
          onClick={() => {
            History.replace(`/order/customer`);
          }}
        >
          Batal &amp; Kembali
        </Button>
        <Button
          type="submit"
          loading={StateForm?.loading}
          className="btn-primary py-md-2"
        >
          Simpan
        </Button>
      </Page.Footer>
    </Page>
  );
};

export default CreateScreen;
